import { render, staticRenderFns } from "./stuffs.vue?vue&type=template&id=e1ae53ce&"
import script from "./stuffs.vue?vue&type=script&lang=js&"
export * from "./stuffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports